<template>
  <Base icon="mdi-google-circles-extended" :satisfied="groupSatisfied || requirement.satisfied" tooltip>
    <span>
      {{ requirement.disciplines.length }}
      {{ requirement.disciplines.length | pluralize('Discipline') }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }} have experience in the discipline of
      <span v-for="discipline in requirement.disciplines">
        {{ discipline != requirement.disciplines[0] ? 'or' : '' }}<br />
        {{ discipline.name }}
      </span>
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
    groupSatisfied: { type: Boolean },
  },
}
</script>
